import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

export default (reducers, preLoadedState, { withThunk = true } = {}) => {
  const middlewares = withThunk ? [thunk] : [];

  if (process.env.NODE_ENV === 'development') {
    const { logger } = require('redux-logger');

    middlewares.push(logger);
  }

  return createStore(reducers, preLoadedState, applyMiddleware(...middlewares));
};
